"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeButton = void 0;
var _openSubscriptionWizard = require("@ori-events/open-subscription-wizard");
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const SubscribeButton = ({
  productCode,
  title,
  disabled,
  isPrimary,
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onSubscribeClick = (0, _react.useCallback)(() => {
    (0, _openSubscriptionWizard.dispatch)({
      detail: {
        type: 'Subscription',
        customerType: 'All',
        productCode
      }
    });
  }, [productCode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    color: isPrimary ? 'primary' : 'default',
    variant: isPrimary ? 'contained' : 'outlined',
    disabled: disabled,
    "data-testid": getTestId(isPrimary ? _constants.SUBSCRIBE_PRIMARY_BUTTON : _constants.SUBSCRIBE_SECONDARY_BUTTON),
    startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Subscription, {}),
    onClick: onClick ?? onSubscribeClick,
    children: title
  });
};
exports.SubscribeButton = SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map